export type Statuses = 'idle' | 'deleted' | 'edited' | 'duplicated' | 'new';

// The row's pending-edit state is keyed by a symbol rather than by a name like
// `status`, which a dataset column can legitimately use. Dataset documents come
// from JSON and therefore never carry symbol keys, so this cannot shadow — or
// be shadowed by — user data.
export const ROW_STATUS: unique symbol = Symbol('rowStatus');

// Rows are identified by the Mongo `_id`, not by the grid's default `id` key:
// `id` is a perfectly legal dataset column name, and writing the row key there
// would shadow the user's own data. `_id` is reserved by Mongo and filtered out
// of the dataset columns, so it can never collide.
export type Row<TStatus = Statuses> = Record<string, unknown> & {
  _id: string;
  [ROW_STATUS]: TStatus;
};

export type RowEdit =
  | { kind: 'deleted' }
  | { kind: 'edited'; changes: Record<string, unknown> }
  | { kind: 'new'; changes: Record<string, unknown> };

export type RowEdits = ReadonlyMap<string, RowEdit>;
